import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/context/AuthContext'
import { ScrollToTop } from '@/components/ScrollToTop'
import { RequireAuth } from '@/components/RequireAuth'
import { AppShell } from '@/components/AppShell'
import { PublicLayout } from '@/components/public/PublicLayout'

// Public pages
import { Home } from '@/pages/public/Home'
import { About } from '@/pages/public/About'
import { Features } from '@/pages/public/Features'
import { ForAgents } from '@/pages/public/ForAgents'
import { Security } from '@/pages/public/Security'
import { Accessibility } from '@/pages/public/Accessibility'
import { Contact } from '@/pages/public/Contact'
import { Help } from '@/pages/public/Help'
import { Awa } from '@/pages/public/Awa'
import { NotFound } from '@/pages/public/NotFound'

// Auth pages
import { SignIn } from '@/pages/SignIn'
import { ForgotPassword } from '@/pages/ForgotPassword'
import { ResetPassword } from '@/pages/ResetPassword'
import { AuthCallback } from '@/pages/AuthCallback'

// Authed pages
import { Dashboard } from '@/pages/Dashboard'
import { CasesList } from '@/pages/CasesList'
import { CaseNew } from '@/pages/CaseNew'
import { CaseDetail } from '@/pages/CaseDetail'
import { Transmit } from '@/pages/Transmit'
import { Reports } from '@/pages/Reports'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Standalone auth surfaces (no public chrome) */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Public marketing site */}
          <Route element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="features" element={<Features />} />
            <Route path="awa" element={<Awa />} />
            <Route path="for-agents" element={<ForAgents />} />
            <Route path="security" element={<Security />} />
            <Route path="accessibility" element={<Accessibility />} />
            <Route path="contact" element={<Contact />} />
            <Route path="help" element={<Help />} />
          </Route>

          {/* Authed app */}
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/cases" element={<CasesList />} />
            <Route path="/cases/new" element={<CaseNew />} />
            <Route path="/cases/:id" element={<CaseDetail />} />
            <Route path="/intake" element={<Navigate to="/cases/new" replace />} />
            <Route path="/transmit" element={<Transmit />} />
            <Route path="/reports" element={<Reports />} />
          </Route>

          {/* 404 inside public chrome */}
          <Route element={<PublicLayout />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
